/**
 * Internal entity helper: type-guard checking whether a string is a parseable URL.
 *
 * Co-located with `entities/widget/ui/InfoCard` (its sole consumer) to keep the
 * entity slice self-contained per FSD layer purity. The features-layer copy at
 * `features/widgets/utils/stringsUtils.ts` is unrelated and was not consumed by
 * any other widget primitive.
 *
 * Not exported from the public barrel — entity-internal only.
 */
export function isValidUrl(url: string | undefined | null): url is string {
  if (!url) return false;
  try {
    new URL(url);
  } catch {
    return false;
  }
  return true;
}
